import { createTheme } from '@material-ui/core/styles';

export default createTheme({
  /* palette: {
    primary: {
      main: '#5adbff',
    },
    background: {
      default: '#094074',
    },
    text: {
      primary: '#fff',
    },
  }, */
  typography: {
    fontSize: 24,
  },
});
